export const PRICING = {
  TRIAL: '0.00€',
  BASIC: '11.99€/year',
  PROFESSIONAL: '4.99€/month',
  ANNUAL_PROFESSIONAL: '49.99€/year',
};
